import { useLocales } from "@/locales";
import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";
import OrderDeposit from "@/assets/img/pay-process/deposit.png";
import DirectDeposit from "@/assets/img/pay-process/direct-deposit.png";
import withdraw from "@/assets/img/pay-process/withdraw.png";
import Image from "@/components/image";

export default function PayProcess() {
  const { translate } = useLocales();
  return (
    <ContentWrap
      leftChildren={
        <CommonWrap>
          <>
            <Box component={"div"} className="title_0" id="deposit-by-orders">
              {translate("faq.order_deposit_process")}
            </Box>
            <Image
              src={OrderDeposit}
              sx={{
                mb: 5,
              }}
            />
          </>
          <>
            <Box
              component={"div"}
              className="title_0"
              id="deposit-by-permanent-addresses"
            >
              {translate("faq.direct_address_recharge_process")}
            </Box>
            <Image
              src={DirectDeposit}
              sx={{
                mb: 5,
              }}
            />
          </>
          <>
            <Box component={"div"} className="title_0" id="withdrawal">
              {translate("faq.withdrawal_process")}
            </Box>
            <Image src={withdraw} />
          </>
        </CommonWrap>
      }
    />
  );
}
